import React from 'react';

import Icon from './components/Icon';

const IconVolumeOff = (props: any) => {
	return <Icon id="sti-volume-off" handle={props.handle} {...props} />;
};

export default IconVolumeOff;
